import { ChannelGroup } from '../../../shared/types';

export const getCurrentChannelGroupId = (
    channelGroups: ChannelGroup[] | undefined,
    channelId: string | undefined
): string => {
    if (!channelId) {
        return '';
    }

    const currentGroup = (channelGroups ?? []).find((group: ChannelGroup) =>
        (group.channelIds || []).includes(channelId)
    );

    return currentGroup?._id || '';
};
